import { render, staticRenderFns } from "./user-container-list.vue?vue&type=template&id=5b808af5&scoped=true"
import script from "./user-container-list.vue?vue&type=script&lang=js"
export * from "./user-container-list.vue?vue&type=script&lang=js"
import style0 from "./user-container-list.vue?vue&type=style&index=0&id=5b808af5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b808af5",
  null
  
)

export default component.exports